import type { ReactNode } from 'react'
import { useEffect } from 'react'

import { THEME } from '@/constants/layout'
import { useLayoutStore } from '@/store/useLayoutStore'

type TTheme = 'light' | 'dark' | 'system'

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { setTheme } = useLayoutStore()

  useEffect(() => {
    const storedTheme = localStorage.getItem('vite-ui-theme') as TTheme | null
    setTheme(storedTheme ?? THEME.LIGHT)
  }, [setTheme])

  return children
}
